var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({class:_setup.classes,attrs:{"disabled":_setup.isDisabled}},_vm.$listeners),[(_vm.icon)?_c('img',{class:_setup.iconClasses,attrs:{"src":_vm.icon,"aria-hidden":"true","alt":""}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }